import "clsx";
import { E as Editor } from "../../../../../chunks/Editor.js";
function _page($$renderer, $$props) {
  $$renderer.component(($$renderer2) => {
    let content = { time: Date.now(), blocks: [] };
    let $$settled = true;
    let $$inner_renderer;
    function $$render_inner($$renderer3) {
      $$renderer3.push(`<h1>Test</h1> `);
      Editor($$renderer3, {
        get value() {
          return content;
        },
        set value($$value) {
          content = $$value;
          $$settled = false;
        }
      });
      $$renderer3.push(`<!---->`);
    }
    do {
      $$settled = true;
      $$inner_renderer = $$renderer2.copy();
      $$render_inner($$inner_renderer);
    } while (!$$settled);
    $$renderer2.subsume($$inner_renderer);
  });
}
export {
  _page as default
};
